import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Line, Room, SearchDispoService, WindowRefService } from '@app/core';

@Component({
    selector: 'app-sur-classement',
    templateUrl: './sur-classement.component.html',
    styleUrls: ['./sur-classement.component.scss']
})
export class SurClassementComponent implements OnInit {
    data: { room: Room, roomOriginal: Room, line: Line } = {
        room: null,
        roomOriginal: null,
        line: null
    };
    constructor(private searchDispoService: SearchDispoService, private winRef: WindowRefService, private dialogRef: MatDialogRef<SurClassementComponent>, @Inject(MAT_DIALOG_DATA) data) {
        this.data.room = data.room;
        this.data.line = data.line;
    }

    ngOnInit() {
        // if(this.data.room.isUpgraded) {
        const roomOriginal: Room = this.searchDispoService.rooms.find(r => r.id == this.data.room.getRoomUpgradeTo())
        this.data.roomOriginal = roomOriginal;
        // }
        //this.searchDispoService.rooms.find(this.data.room.isUpgraded);
    }

    getBaseUrlImg(size: string): string {
        return this.winRef.appConfigSite.hosteimageimg + 'images/' + this.winRef.appConfigSite.idEtab + '/upload/' + size + '/';
    }

    /**
    * lang
    * @returns string lang
    */
    get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

}
